// Stability level metadata and recommendations
export const STABILITY_META = {
  'Low Stability': {
    gradient: 'from-red-500 to-rose-600',
    smartPhase: 'Scan & Map',
    recommendations: [
      'Prioritize workflow documentation and process mapping',
      'Clarify roles and decision authority distribution',
      'Develop Standard Operating Procedures (SOPs)',
      'Establish knowledge transfer mechanisms',
      'Stabilize manual processes before automation'
    ]
  },
  'Moderate Stability': {
    gradient: 'from-amber-500 to-orange-600',
    smartPhase: 'Analyse & Redesign',
    recommendations: [
      'Standardize work routines across teams',
      'Identify and remove process bottlenecks',
      'Reduce rework and repetitive activities',
      'Improve process control mechanisms',
      'Prepare for selective automation opportunities'
    ]
  },
  'High Stability': {
    gradient: 'from-emerald-500 to-teal-600',
    smartPhase: 'Transform',
    recommendations: [
      'Map AI opportunity areas in current workflows',
      'Develop automation prioritization roadmap',
      'Build dashboards for performance monitoring',
      'Establish AI governance framework',
      'Plan phased digital transformation'
    ]
  }
};

export const getStabilityMeta = (level) => {
  return STABILITY_META[level] || STABILITY_META['Moderate Stability'];
};

export const classifyWorkflow = (wf) => {
  const automationScore = [
    wf.is_repetitive,
    wf.is_rule_based,
    wf.is_digital_input,
    wf.is_predictable_output,
    wf.is_high_volume
  ].filter(Boolean).length;

  if (wf.requires_judgment) {
    return automationScore >= 4
      ? { category: 'AI-Assisted Work', color: 'bg-blue-50 border-blue-300 text-blue-700' }
      : { category: 'Human Judgment Required', color: 'bg-purple-50 border-purple-300 text-purple-700' };
  }
  return automationScore >= 4
    ? { category: 'Automate Now', color: 'bg-green-50 border-green-300 text-green-700' }
    : { category: 'Redesign First', color: 'bg-amber-50 border-amber-300 text-amber-700' };
};
